import { isMobile } from 'app/device';

// caution: this is used to compute the geometry of grid items and initial setup of the grid scroll
export const maxCols = isMobile ? 4 : 6;
